import { ListChecks } from 'lucide-react';

import { TrackingEventsV2 } from '../../../../analytics/eventsV2';
import { Icon } from '../../icon';
import { Button } from '../../shadcn/button';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { cn } from '@/helpers/shadCnUtils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';

export const ShowFactsIcon = ({
  showFacts,
  setShowFacts,
}: {
  showFacts: boolean;
  setShowFacts: (showFacts: boolean) => void;
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="blue"
          size="sm"
          onClick={() => {
            setShowFacts(!showFacts);
            trackCustomEvent(TrackingEventsV2.ShowAllFactsInDocViewer);
          }}
          className={cn(showFacts ? 'bg-sky-100' : '')}
        >
          <Icon className="lucide--list-checks text-sm" />
          <span className="text-xs">Show All Facts</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Show all facts in document</p>
      </TooltipContent>
    </Tooltip>
  );
};
